import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)<{ backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.small}px;
  position: relative;
  border: 1px solid ${theme.colors.strokePrimary};

  html[data-theme='light'] & {
    border-color: ${theme.colors.dropdownBorder};
  }

  ${({ backgroundColor }) => `
    background-color: ${backgroundColor};
  `};

  .MuiTypography-root {
    color: ${theme.colors.foreground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxxLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: normal;

    html[data-theme='light'] & {
      /* cells are filled with saturated budget greens, so the value stays white as in dark */
      color: #ffffff;
    }
  }

  .edit-icon-button {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 0 0 ${theme.attributes.borderRadius.secondary};
    background: ${theme.colors.cta};
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    padding: 0;
    opacity: 0;

    html[data-theme='light'] & {
      /* CSS fill beats the glyph's own presentation attribute, which can't take a var() */
      svg path {
        fill: ${theme.colors.menuItemHover};
      }
    }
  }

  &:hover {
    .edit-icon-button {
      opacity: 1;
    }
  }

  &:hover {
    border-color: ${theme.colors.controlBorder};

    &:not(.with-items) {
      background: ${theme.colors.legacySurface502};
    }
  }
`
